// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"545":"1071aa3f","629":"a01201df","670":"2ba7d923"}[chunkId] + ".chunk.css";
};